<template>
  <div id="app">
    <router-view v-if="isReload"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isReload: true
    }
  },
  methods: {
    reload () {
      this.isReload = false
      this.$nextTick(() => {
        this.isReload = true
      })
    }
  }
}
</script>

<style lang="scss">
	 @import url('~normalize.css/normalize.css');// normalize.css 样式格式化
	 @import './styles/index.scss'; // 全局自定义的css样式
	 @import url('./styles/common.css'); // 全局公共样式
  #app{
    height: 100%;
  }
</style>